<template>
	<div class="contentHome">
		<div class="centerPage">
			<el-breadcrumb separator-class="el-icon-arrow-right" class="breadCrumb">
				<el-breadcrumb-item><a href="javascript:;" class="aHref" @click="$router.push({path: '/' + doctorAccount})">医生详情</a></el-breadcrumb-item>
				<el-breadcrumb-item>预约订单</el-breadcrumb-item>
			</el-breadcrumb>
			<el-steps :active="active" align-center class="stepRes">
				<el-step v-for="(item,index) in titleList" :title="item.title" :key="index"></el-step>
			</el-steps>
			<h3 class="statement">网站声明：您与医生的咨询不会被录音和录像；你们的交流纯属隐私，绝对保密。</h3>
			<div :state="doctorState" style="text-align: center;">对方{{ doctorState == 0 ? '未' : '已' }}就绪.</div>
			<div class="flex chat-comment">
				<div class="chat-div">
					<!-- z-index: -->
					<!-- rv:1  lv: 10  ov:50  ui: 50 -->
					<div id="video-user-info" v-if="state!=3">
						<div><img :src="doctorAvatar" alt="用户头像"></div>
						<div class="user-name"><span>{{ doctorName }}</span></div>
					</div>
					<div id="local-video"></div>
					<div id="remote-video"></div>
					<div id="operate-group">
						<span v-if="state==3" @click="hangupCall" class="op hangup"><i class="el-icon-phone"></i></span>
					</div>
					<div v-if="consultMode==1 && state>1" class="mode-tips">当前语音模式</div>
					<div v-if="consultMode==2 && state<2" class="mode-tips">当前视频模式</div>
				</div>
				<div class="chatCom">
					<div class="wxchatBorderRightTop">{{ doctorName }}</div>
					<div class="wxchatBorderRightMid" id="chatRecord">
						<el-row v-for="msg in msgList" :key="msg.id">
							<template v-if="msg.type == 2">
								<el-col :span="22">
									<div class="chatPop2 chatPop">
										<template v-if="msg.msgType == 'img'">
											<el-image
												style="width: 100px; height: 100px"
												:src="msg.content"
												:preview-src-list="[msg.content]"
												fit="contain"></el-image>
										</template>
										<template v-else>
											{{ msg.content }}
										</template>
									</div>
								</el-col>
								<el-col :span="2">
									<el-avatar :src="userAvatar" :size="27"></el-avatar>
								</el-col>
							</template>
							<template v-else>
								<el-col :span="2">
									<el-avatar :src="doctorAvatar" :size="27"></el-avatar>
								</el-col>
								<el-col :span="22">
									<div class="chatPop1 chatPop">
										<template v-if="msg.msgType == 'img'">
											<el-image
												style="width: 100px; height: 100px"
												:src="msg.content"
												:preview-src-list="[msg.content]"
												fit="contain"></el-image>
										</template>
										<template v-else>
											{{ msg.content }}
										</template>
									</div>
								</el-col>
							</template>
						</el-row>
					</div>
					<div class="wxchatBorderRightBottom">
						<el-input type="textarea" :autosize="{ minRows: 3, maxRows: 3}" placeholder="请输入聊天内容" v-model="msgContent"
							resize="none" autofocus maxlength="200" show-word-limit>
						</el-input>
						<div class="sendButton">
							<el-upload
								class="upload-demo"
								action=""
								:before-upload="handleChatImgBeforeUpload"
								accept="image/png,image/gif,image/jpg,image/jpeg"
								:show-file-list="false">
								<span class="el-icon-picture-outline upload">上传图片</span>
							</el-upload>
							<el-button @click="sendMessage">发送</el-button>
						</div>
					</div>
				</div>
			</div>
		</div>

		<el-dialog
			:title="(consultMode==1?'语音':'视频') + '通话邀请'"
			:visible.sync="inviteWaitDialog"
			width="30%"
			:close-on-click-modal="false"
			:close-on-press-escape="false"
			:show-close="false">
			<p><span
				style="color: black;font-size: 16px;margin-right: 10px;">{{
          doctorName
        }}</span>邀请你进行{{ consultMode == 1 ? '语音' : '视频' }}通话...
			</p>
			<p style="margin-top: 8px"><i class="el-icon-loading"></i>等待接听: {{ inviteWaitTime }}s</p>
			<span slot="footer" class="dialog-footer invite-operate">
				<el-button type="danger" @click="handleRejectInvite(false)" icon="el-icon-phone" circle
					style="margin-right: 20px;"></el-button>
				<el-button type="success" @click="handleAcceptInvite" icon="el-icon-phone-outline" circle></el-button>
		  	</span>
		</el-dialog>


    <!-- 视频通话邀请 -->
    <el-dialog title="视频请求确认"
               width="360px"
               :visible.sync="applyUpgradeDialog.show"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               :show-close="false">
      <p>对方向你请求视频画面, 是否同意?</p>
      <span slot="footer" class="dialog-footer invite-operate">
        <el-button type="danger" @click="handleUpgradeApply(false)" style="margin-right: 20px;">拒绝</el-button>
				<el-button type="success" @click="handleUpgradeApply(true)">同意({{applyUpgradeDialog.expire}})</el-button>
      </span>
    </el-dialog>


	</div>
</template>

<script>
  import base from '@/api/common';
  import {Tooltip} from 'element-ui';
  import TRTCCalling from 'trtc-calling-js';

  let isNotice = false;
  export default {
    name: "chat",
    data() {
      return {
        userAvatar: '',// 自己的头像
        doctorAvatar: '',// 医生头像
        doctorName: '',// 医生名称
        doctorAccount: '',
        appointId: '',
        consultMode: 0,
        userId: '',
        loading: false,
        active: 2,
        titleList: [{title: '填写订单'}, {title: '付款'}, {title: '咨询'}],

        state: 0, // 0-未就绪 1-就绪 2-拨号中 3-通话中
        doctorState: 0,

        VueWebSocket: null,
        VueTRTCCalling: null,

        inviteWaitDialog: false,
        inviteWaitTime: 60,
        inviteWaitInterval: 0,

        curInviteId: '', // 邀请ID
        curInviteRoomId: 0,
        curCallType: 0,

        webSocketHealthInterval: 0,
        msgContent: '',
        msgList: [],

        documentHiddenState:{
          timeout: 300000, //5分钟
          activeTimeoutTimer: 0, // 用户活动定时器
          hidden: '',
          visibilityChange: '',
          state: '',
        },

        applyUpgradeDialog:{
          show: false,
          code: '',
          expire: 0,
          timer: 0
        }

      }
    },
    watch: {
      msgList(val,oval){
        this.$nextTick(()=>{
          document.querySelector("#chatRecord").scrollTop = document.querySelector("#chatRecord").scrollHeight;
        })
      }
    },
    components: {[Tooltip.name]: Tooltip},
    async mounted() {
      let vm = this, id = vm.$route.params.id;

      let res = await this.$ajax.get(base.api.user.appointDetail.replace('{id}', id)).then(res => {
        if (res.data.status === 'success') {
          vm.appointId = id;
          vm.room = res.data.data.appoint.account;
          vm.doctorAvatar = res.data.data.appoint.headimgdoctor;
          vm.userAvatar = res.data.data.appoint.headimguser;
          vm.doctorName = res.data.data.appoint.doctorName;
          vm.consultMode = res.data.data.appoint.consultMode;
          vm.doctorAccount = res.data.data.appoint.account;
          // 初始化房间
          return true;
        }
        return false;
      }).catch((err) => {

      });
      if (!res) {
        return;
      }
      vm.initWebSocket();

      vm.addListenerForUserActive();// 窗口离开监听
    },
    inject: ['reload'],
    destroyed() {
      this.destroyTrtc();
    },
    methods: {
      destroyTrtc(){
        try {
          this.removeListener();
          // 关闭trtc连接
          if(this.VueTRTCCalling){
            this.VueTRTCCalling.hangup();
            this.VueTRTCCalling.logout();
            this.VueTRTCCalling = null;
          }
          // 断开websocket
          this.VueWebSocket.close();
        }catch (e) {
          console.error('destroyTrtc: ' + e);
        }
      },
      remindTips(type){
        if(!type){return;}
        let alertMsg = '';
        switch (type) {
						case 'tips': alertMsg = '本次通话即将到达预约结束时间,请注意通话时长!';  break;
						case 'timeout': alertMsg = '本次通话已超时,请注意通话时长!'; break;
						case '': alertMsg = '';break;
        }
        this.$messageBox.alert(alertMsg,{title:'系统提示', type: 'warning'});
			},
      sendMessage() {
        if (this.msgContent.trim().length === 0) {
          this.$message.warning("请先输入内容");
          return false;
        }
        if (this.VueWebSocket && this.VueWebSocket.readyState === 1) {
          let msg = {
            type: 2,
            name: localStorage.name || '',
            content: this.msgContent,
            msgType: 'text'
          };
          this.VueWebSocket.send(JSON.stringify(msg));
          this.msgList = [
            ...this.msgList,
            msg
          ]
          this.msgContent = '';
        }
      },
      handleChatImgBeforeUpload(file) {
        const vm = this;
        const isLt10M = file.size / 1024 / 1024 < 10;
        if (!isLt10M) {
          vm.$message.error("上传图片大小不能超过10M");
          return false;
        } else {
          // 压缩
          //console.log(file)
          base.utils.compress(file, (val) => {
            // 上传
            //console.log('*********val', val)
            let thumbfile = new window.File([val], file.name, {type: file.type});
            // console.log("********thumbfile", thumbfile)

            let formData = new FormData(); // 通过formdata上传
            formData.append('uploadFile', thumbfile);
            this.$ajax.post(base.api.upload.chatImg, formData, {
              headers: {'Content-Type': 'multipart/form-data'}
            }).then((res) => {
              if (res.status === 200 && res.data.status === 'success') {
                if (this.VueWebSocket && this.VueWebSocket.readyState == 1) {
                  let msg = {
                    type: 2,
                    name: localStorage.name || '',
                    content: res.data.message,
                    msgType: 'img'
                  };
                  this.VueWebSocket.send(JSON.stringify(msg));
                  this.msgList = [...this.msgList,msg];
                }
              } else {
                this.$message.error(res.data.message);
              }
            }).catch((err) => {
              console.error(err);
              this.$message.error('操作失败');
            })
          });

          return false;
        }
      },
      initTRTCCalling() { // 获取房间签名
        let that = this;
        that.$ajax.post(base.basePath + "medical/appoint/consult/authorize/room/sign/web/" + that.appointId).then(res => {
          if (res.data.status === 'success') {
            let userID = res.data.data.userId;
            that.VueTRTCCalling = new TRTCCalling({
              SDKAppID: res.data.data.sdkAppId //
            });
            that.VueTRTCCalling.setLogLevel(1); // 设置日志级别
            that.VueTRTCCalling.login({
              userID,
              userSig: res.data.data.userSig,
              privateMapKey: res.data.data.privateMapKey
            });
            // 绑定监听事件
            that.initTRTCListener();
            that.state = 1; //就绪
          }
        });
      },
      initTRTCListener() {
        let that = this;
        if (!this.VueTRTCCalling) {
          return;
        }
        this.VueTRTCCalling.on( // 错误处理
          TRTCCalling.EVENT.ERROR,
          that.handleError
        );
        this.VueTRTCCalling.on( // 收到邀请事件
          TRTCCalling.EVENT.INVITED,
          that.handleInvitationReceived
        );
        this.VueTRTCCalling.on( // 拨号取消off
          TRTCCalling.EVENT.CALLING_CANCEL,
          that.handleCallCancel
        );
        this.VueTRTCCalling.on( // 医生进入
          TRTCCalling.EVENT.USER_ENTER,
          that.handleDoctorEnter
        );
        this.VueTRTCCalling.on(// 通话结束
          TRTCCalling.EVENT.CALL_END,
          that.handleCallEnd
        );

      },
      removeListener() {
        let that = this;
        if (!this.VueTRTCCalling) {
          return;
        }
        this.VueTRTCCalling.off( // 错误处理off
          TRTCCalling.EVENT.ERROR,
          that.handleError
        );
        this.VueTRTCCalling.off( // 收到邀请事件off
          TRTCCalling.EVENT.INVITED,
          that.handleInvitationReceived
        );
        this.VueTRTCCalling.off( // 拨号取消off
          TRTCCalling.EVENT.CALLING_CANCEL,
          that.handleCallCancel
        );
        this.VueTRTCCalling.off( // 医生进入off
          TRTCCalling.EVENT.USER_ENTER,
          that.handleDoctorEnter
        );
        that.VueTRTCCalling.off(// 通话结束off
          TRTCCalling.EVENT.CALL_END,
          that.handleCallEnd
        );
      },
      handleError(e) {
        console.error("发生错误: ", e)
      },
      async handleInvitationReceived(e) {
        let that = this;
        that.curInviteId = e.inviteID;
        that.curInviteRoomId = e.inviteData.roomID;

        that.curCallType = e.inviteData.callType;

        that.inviteWaitTime = 60; //时间重置
        that.inviteWaitDialog = true;

        that.state = 2; //等待接听

        if (that.inviteWaitInterval) clearInterval(that.inviteWaitInterval);
        that.inviteWaitInterval = setInterval(() => {
          that.inviteWaitTime--;
          if (that.inviteWaitTime <= 0) {
            that.handleRejectInvite(true); //时间到拒绝(忙线)
          }
        }, 1000);
      },
      handleRejectInvite(isBusy) { // 拒绝
        if (!isBusy) {
          isBusy = false;
        }
        let that = this;
        that.inviteWaitDialog = false;
        clearInterval(that.inviteWaitInterval);
        let inviteID = that.curInviteId;
        that.VueTRTCCalling.reject({inviteID, isBusy});
        if (!isBusy) { //直接拒绝
          that.$message.info("你已拒绝.");
        }
      },
      async handleAcceptInvite() { //接受
        let that = this;
        that.inviteWaitDialog = false;
        clearInterval(that.inviteWaitInterval);

        await that.VueTRTCCalling.accept({
          inviteID: that.curInviteId,
          roomID: that.curInviteRoomId,
          callType: that.curCallType
        });
      },
      handleCallCancel() {
        this.state = 1;
        this.$messageBox.alert('对方已取消');
        this.inviteWaitDialog = false;
        clearInterval(this.inviteWaitInterval);
      },
      handleDoctorEnter(e) {
        let that = this;

        let doctorId = e.userID;
        let userID = that.userId;

        let lvID = 'lvID-' + Math.random().toString(36).slice(-4);
        let rvID = 'rvID-' + Math.random().toString(36).slice(-4);
        $("#local-video").html('<div id="' + lvID + '"></div>');
        $("#remote-video").html('<div id="' + rvID + '"></div>');

        setTimeout(() => { // 延时执行保证dom加载
          that.VueTRTCCalling.startRemoteView({
            userID: doctorId,
            videoViewDomID: rvID
          });
          // 开启本地视频
          that.VueTRTCCalling.startLocalView({
            userID,
            videoViewDomID: lvID
          });
          that.state = 3; // 通话中
        }, 1500);
      },
      handleCallEnd(e) {
        this.state = 1;
        this.$messageBox.alert('对方已结束通话');
        $("#local-video").html(""); //清空本地视频
      },


      //TODO other function
      initWebSocket() {
        let that = this;
        that.$ajax.post(base.api.appoint.consult.roomToken.replace("{id}", that.appointId)).then(res => {
          if (res.data.status === 'success') {
            that.userId = res.data.userId;
            let socketUrl = base.api.appoint.consult.socketUrl.replace("{room}", that.appointId).replace("{userId}", res.data.userId);
            that.VueWebSocket = new WebSocket(socketUrl + "?token=" + res.data.token); //校验token
            that.VueWebSocket.onopen = () => {
              // 初始化trtc
              that.initTRTCCalling();
              that.VueWebSocket.send('ready');
              // 心跳
              that.webSocketHealthInterval = setInterval(() => {
                if (that.VueWebSocket && that.VueWebSocket.readyState == 1) {
                  try {
                    that.VueWebSocket.send(Math.random().toString(36).slice(-4));
                  } catch (e) {
                    clearInterval(that.webSocketHealthInterval); // 停止心跳
                  }
                } else {
                  clearInterval(that.webSocketHealthInterval); // 停止心跳
                  that.doctorState = 0;
                }
              }, 3000);
            };
            that.VueWebSocket.onclose = () => {
              that.destroyTrtc();
              if(that.$route.name == 'chat'){
                that.$messageBox.alert('会话连接已断开').then(()=>{
                  that.$router.push('/user/counsel');
                });
              }
            };
            that.VueWebSocket.onerror = () => {
              that.$message.error("获取医生状态时错误，请刷新页面重试！")
            };
            that.VueWebSocket.onmessage = (e) => {
              let message = e.data;
              if (message === 'ready') { // 医生就绪
                // trtc 等待拨号邀请
                that.doctorState = 1;
                if (!isNotice) {
                  that.$message.success("对方已就绪!");
                  isNotice = true;
                }
              } else if (message === 'leave') { // 医生离开
                that.doctorState = 0;
                that.$message.warning('对方已离开');
                isNotice = false;
              } else if (message.startsWith("{") && message.endsWith("}")) {// 聊天消息
                const chatMsg = JSON.parse(message);
                if(chatMsg.type === 0){ // 系统消息
                  if(chatMsg.msgType == 'cmd'){
                    if(chatMsg.cmd == 'upgrade'){
                      // 弹窗提醒是否同意
                      that.applyUpgradeDialog.expire = chatMsg.expire;
                      that.applyUpgradeDialog.code = chatMsg.code;
                      that.applyUpgradeDialog.show = true;

                      that.applyUpgradeDialog.timer = setInterval(()=>{
                        that.applyUpgradeDialog.expire--;
                        if(that.applyUpgradeDialog.expire <= 0){
                          that.applyUpgradeDialog.show = false;
                          clearInterval(that.applyUpgradeDialog.timer);
                        }
                      },1000);
                    }
                    return;
                  }
									that.remindTips(chatMsg.msgType);
								}else{
                  that.msgList = [...that.msgList,{
                    type: 1,
                    name: that.doctorName,
                    content: chatMsg.content,
                    msgType: chatMsg.msgType || 'text'
                  }];
								}
              }
            };
          }
        }).catch(err => {
          console.error(err);
        })
      },
      hangupCall() {
        let that = this;
        this.$messageBox.confirm('确定要挂断吗?').then(() => {
          that.VueTRTCCalling.hangup();
          that.state = 1;
        });
      },
      addListenerForUserActive(){ // 添加监听, 监听用户是否离开此页面
        let hidden, state, visibilityChange;
        if (typeof document.hidden !== "undefined") {
          hidden = "hidden";
          visibilityChange = "visibilitychange";
          state = "visibilityState";
        } else if (typeof document.mozHidden !== "undefined") {
          hidden = "mozHidden";
          visibilityChange = "mozvisibilitychange";
          state = "mozVisibilityState";
        } else if (typeof document.msHidden !== "undefined") {
          hidden = "msHidden";
          visibilityChange = "msvisibilitychange";
          state = "msVisibilityState";
        } else if (typeof document.webkitHidden !== "undefined") {
          hidden = "webkitHidden";
          visibilityChange = "webkitvisibilitychange";
          state = "webkitVisibilityState";
        }
        let that = this;
        that.documentHiddenState.hidden = hidden;
        that.documentHiddenState.visibilityChange = visibilityChange;
        that.documentHiddenState.state = state;
        // 添加监听器,监听当前是否活动页面
        document.addEventListener(visibilityChange, that.activeListener, false);
      },
      activeListener(){
        let that = this;
        let isHidden = document[that.documentHiddenState.state] == that.documentHiddenState.hidden;
        if(isHidden){
          that.activeTimeoutTimer = setTimeout(()=>{
            document.removeEventListener(that.documentHiddenState.visibilityChange,that.activeListener,false);
            // 清除trtc
            that.destroyTrtc();
            that.$router.push('/index');
          },that.documentHiddenState.timeout); // 非活动时间
        }else{
          clearTimeout(that.activeTimeoutTimer)
        }
      },
      handleUpgradeApply(isAgree){
        let that = this;
        if(isAgree){
          let code = that.applyUpgradeDialog.code;
          let id = that.appointId;
          that.$ajax.post(base.basePath + `medical/appoint/consult/authorize/room/upgrade/${id}?code=${code}`).then(res=>{
            if(res.data.status === 'success'){
              that.$messageBox.alert('3秒后将重新进入房间').then(()=>{
                setTimeout(()=>{
                  location.reload();
                },3000);
              });
              let msg = {
                type: 0,
                msgType: 'result',
                cmd: 'upgrade',
                result: 'accept'
              };
              that.VueWebSocket.send(JSON.stringify(msg));
            }
          });
        }else{
          let msg = {
            type: 0,
            msgType: 'result',
            cmd: 'upgrade',
            result: 'reject'
          };
          that.VueWebSocket.send(JSON.stringify(msg));
          that.$message.info("你已拒绝");
        }
        // 结束状态
        that.applyUpgradeDialog.expire = 0;
        that.applyUpgradeDialog.show = false;
        that.applyUpgradeDialog.code = '';
        if(that.applyUpgradeDialog.timer){
          clearInterval(that.applyUpgradeDialog.timer);
        }
      }
    }
  }
</script>

<style scoped lang="scss">
	@import '../../assets/css/chat.scss';

	div[state='0'] {
		color: #F56C6C;
		font-size: 14px
	}

	div[state='1'] {
		color: #67C23A;
		font-size: 14px
	}


</style>

<style lang="css">
.invite-operate i {
	font-size: 20px
}

#local-video > div {
	height: 150px;
}

#remote-video > div {
	height: 100%;
}
span.el-image-viewer__btn.el-image-viewer__close{top: 140px}
span.el-image-viewer__btn.el-image-viewer__close i{color: #FFF;}
</style>
